/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import { combineReducers } from 'redux'; // Basic application support reducers

import adaViolationsReducer from './ada-violations/reducer';
import businessEventsReducer from './business-events/reducer';
import cspViolationsReducer from './csp-violations/reducer';
import consoleReducer from './console/reducer';
import deviceFeatureReducer from './device-feature/reducer';
import languageReducer from './language/reducer';
import moduleErrorReducer from './module-error/reducer';
import navigationMenuReducer from './navigation-menu/reducer';
import navigationReducer from './navigation/reducer';
import scenarioReducer from './scenarios/reducer';
import screenSizeReducer from './screen-size/reducer';
import sessionReducer from './session/reducer';
import stopMessageReducer from './stop-message/reducer';
import toolboxReducer from './toolbox/reducer';
import workflowReducer from './workflows/reducer';
import confirmationReducer from './confirmation/reducer';
import pageReducer from './page/reducer';
import globalSearchReducer from './global-search/reducer';
import tealiumReducer from './tealium/reducer';
import settingsReducer from './settings/reducer';
import wfuiBridgeReducer from './wfui-bridge/reducer';
import chatbotReducer from './chatbot/reducer';
import nuanceReducer from './nuance/reducer';
var coreReducer = combineReducers({
  adaViolations: adaViolationsReducer,
  businessEvents: businessEventsReducer,
  cspViolations: cspViolationsReducer,
  console: consoleReducer,
  deviceFeature: deviceFeatureReducer,
  language: languageReducer,
  moduleError: moduleErrorReducer,
  navigation: navigationReducer,
  navigationMenu: navigationMenuReducer,
  scenarios: scenarioReducer,
  screenSize: screenSizeReducer,
  session: sessionReducer,
  stopMessage: stopMessageReducer,
  toolbox: toolboxReducer,
  workflow: workflowReducer,
  confirmation: confirmationReducer,
  page: pageReducer,
  globalSearch: globalSearchReducer,
  tealium: tealiumReducer,
  settings: settingsReducer,
  wfuiBridge: wfuiBridgeReducer,
  chatbot: chatbotReducer,
  nuance: nuanceReducer
});
export default coreReducer;